module.exports = __webpack_public_path__ + "static/media/icon-4.275dc54a.png";